// TODO: We want to remove this once we move away from the redux error handling
import error from "@classdojo/web/pods/errorHandling";
import groups from "./pods/groups";
import ideas from "./pods/ideas";
import list from "./pods/list";
import microphonePermissions from "./pods/microphonePermissions";
import noise from "./pods/noise";
import npsSurvey from "./pods/npsSurvey";
import nuxMetadata from "./pods/nuxMetadata";
import pairshare from "./pods/pairshare";
import parentStudents from "./pods/parentStudents";
import radio from "./pods/radio";
import random from "./pods/random";
import realtime from "./pods/realtime";
import students from "./pods/students";
import timer from "./pods/timer";
import today from "./pods/today";
import toolkitData from "./pods/toolkitData";
import variant from "./pods/variant";
import webviewInit from "./pods/webviewInit";
import auth from "pods/auth";
import board from "pods/board";
import logs from "pods/logs";

import "./pods/font";

// ios pod last so that the event can be listened to by the other pods
export default [
  error,
  auth,
  logs,
  board,
  webviewInit,
  auth,
  realtime,
  pairshare,
  timer,
  random,
  groups,
  radio,
  noise,
  today,
  list,
  students,
  microphonePermissions,
  ideas,
  toolkitData,
  parentStudents,
  nuxMetadata,
  variant,
  npsSurvey,
];
